/* wersja: 2026-09-01T15:4x — wymuszenie nowego ?v= po zlepieniu cache CDN */
if (!customElements.get("product-configurator")) {
  /* Adres ostatniego przerenderowania cen. Zmienna MODULOWA, nie pole instancji:
     zmiana stelaza laduje inny produkt i podmienia cala sekcje, wiec powstaje NOWY
     element konfiguratora z czystym stanem - a on odpalal to samo zapytanie jeszcze
     raz. Dwa identyczne renderowania sekcji po ~950 ms kazde, jedno po drugim. */
  let ostatniAdresCen = null;

  class ProductConfigurator extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector("[data-content]");
      this.loader = this.querySelector(".loader");
      this.footer = this.querySelector("[data-footer]");
      this.footerPrice = this.querySelector("[data-footer-price]");
      this.footerParams = this.querySelector("[data-footer-params]");
      this.footerSubmit = this.querySelector("[data-footer-submit]");
      this.productForm = null;
      this.currencySymbol = this.dataset.currencySymbol || "zł";
      this.variants = JSON.parse(this.dataset.variants || "[]");
      this.isNavigating = false;

      // Generic surcharge product state — keyed by option handle
      this._surchargeData = {};
    }

    connectedCallback() {
      this.productForm = document.querySelector("product-form");
      
      // When the component is detached and re-attached (e.g. during section replacement),
      // we only need to update the product-form reference. We shouldn't re-bind all
      // window/document event listeners as that leads to duplicate handlers and 429 rate limit errors.
      if (this.dataset.initialized === "true") return;
      this.dataset.initialized = "true";

      // Faza przechwytywania: musi wyprzedzic obsluge etykiet karty tkaniny.
      this.addEventListener("click", (event) => this.oznaczKlikOpisu(event), true);

      // Karta tkaniny BAZOWEJ jest klikalna w calosci - tak samo jak karta premium.
      // Wczesniej dalo sie w nia wejsc tylko przez odcien w rozwinietej liscie, a ta
      // otwiera sie przyciskiem "Zmien" stojacym w pasku koloru. Pasek pokazuje sie
      // tylko na karcie WYBRANEJ, wiec po przejsciu na tkanine premium nie bylo juz
      // czym wrocic na bazowa - karta stala bez zadnego elementu do klikniecia.
      this.addEventListener("click", (event) => this.klikKartyBazowej(event));

      if (!this.productForm) return;

      // Listen for the drawer opening
      const drawer = this.closest("drawer-section");
      if (drawer) {
        window.addEventListener("drawerOpen", (e) => {
          if (e.detail.id === drawer.id) {
            this.onDrawerOpen();
          }
        });
      }

      /* Panel nie moze przewijac sie pod kursorem przy wyborze opcji.
         Klikniecie w karte przenosi ognisko na ukryte pole wyboru, a przegladarka
         przewija, zeby je pokazac - przy kartach czesciowo widocznych panel
         skakal o kilkaset pikseli (zgloszenie 26 sie 2026). Zapamietujemy
         pozycje przy nacisnieciu i przywracamy ja, gdy ognisko trafia na pole
         w tej samej interakcji. Nawigacja klawiatura (Tab) przewija dalej -
         tam przewinięcie jest pozadane, bo inaczej ognisko ucieka z ekranu. */
      this.addEventListener(
        "pointerdown",
        (e) => {
          if (!e.target.closest(".product-configurator__option")) return;

          const scroller = this.content?.closest(".drawer__scroll");

          if (!scroller) return;

          this.scrollLock = { scroller, top: scroller.scrollTop };
          window.setTimeout(() => {
            this.scrollLock = undefined;
          }, 400);
        },
        true
      );

      this.addEventListener(
        "focusin",
        (e) => {
          if (!this.scrollLock) return;
          if (!e.target.matches(".product-configurator__option input")) return;

          this.scrollLock.scroller.scrollTop = this.scrollLock.top;
        },
        true
      );

      /* Wybor opcji przez DELEGACJE, nie przez podpinanie do kazdego kafla.

         Blad, ktory to naprawia (zgloszenie 7.09.2026): "aby zmienic pojemnik
         musze klikac dwa razy".

         Przyczyna: zmiana pojemnika to przejscie na INNY produkt, wiec
         `reloadProductSection` podmienia zawartosc sekcji przez `innerHTML`.
         Poprzednia wersja zbierala kafle raz, przy starcie, i wieszala uchwyt
         na kazdym z osobna - po podmianie nowe kafle byly juz bez uchwytow.
         Pierwsze klikniecie trafialo w prozne, dopiero kolejne dzialalo,
         gdy komponent zdazyl sie przeinicjowac.

         Jeden nasluch na kontenerze przezywa kazda podmiane zawartosci, bo
         kontener sie nie zmienia. To takze zdejmuje czesc dlugu opisanego
         przy naprawie blokad konfiguratora (jednorazowe podpiecia + innerHTML). */
      this.content.addEventListener("click", (e) => {
        const label = e.target.closest(".product-configurator__option");
        if (!label || !this.content.contains(label)) return;

        // "pelen opis" i lupa siedza w karcie, ale nie sa sposobem jej wyboru -
        // maja zachowac wlasne dzialanie (nowa karta, szuflada).
        if (e.target.closest(".product-configurator__option-link")) return;
        if (e.target.closest(".product-configurator__swatch-zoom")) return;

        e.preventDefault();
        this.onOptionClick(label);
      });

      // "Zobacz wiecej" reveals the rest of a collapsed card grid.
      this.content.addEventListener("click", (e) => {
        const more = e.target.closest("[data-showmore]");
        if (!more) return;

        const grid = more
          .closest(".product-configurator__section")
          ?.querySelector("[data-showmore-grid]");

        if (grid) grid.classList.remove("is-collapsed");
        this.updateShowMore();
      });

      // "pelen opis" na karcie materaca: opis materaca jest juz napisany na jego karcie
      // produktu, wiec przenosimy go tutaj, zamiast wyrzucac klienta z konfiguratora.
      this.content.addEventListener("click", (e) => {
        const trigger = e.target.closest("[data-mattress-details]");
        if (!trigger) return;

        e.preventDefault();
        this.openMattressDetails(
          trigger.dataset.mattressDetails,
          trigger.dataset.mattressDetailsName,
        );
      });

      // Opis materaca dogrzewany jeszcze przed klikniecie: samo najechanie na karte
      // (albo dojscie do niej klawiatura) zaczyna pobieranie, wiec szuflada otwiera
      // sie z gotowa trescia. Pobranie idzie raz na materac - dalej jest z pamieci.
      ["pointerenter", "focusin"].forEach((type) => {
        this.content.addEventListener(
          type,
          (e) => {
            const trigger = e.target.closest?.("[data-mattress-details]");
            if (trigger) this.prefetchMattressDetails(trigger.dataset.mattressDetails);
          },
          true,
        );
      });

      // "pelen opis" na karcie stelaza: kazda karta niesie wlasny szablon tresci,
      // ktory wstawiamy do wspolnego okna (Figma 1:5947).
      this.content.addEventListener("click", (e) => {
        const trigger = e.target.closest("[data-option-details]");
        if (!trigger) return;

        e.preventDefault();
        this.openOptionDetails(trigger.closest(".product-configurator__option"));
      });

      const wishlistProxy = document.querySelector(
        "#drawer-product-configurator [data-wishlist-proxy]",
      );

      if (wishlistProxy) {
        wishlistProxy.addEventListener("click", () => {
          document
            .querySelector(".iwish-app-block-product .iWishAdd, .iWishAdd")
            ?.click();
        });
      }

      // The summary modal is filled from the DOM the user just clicked through.
      window.addEventListener("drawerOpen", (e) => {
        if (e.detail.id === "drawer-configurator-summary") this.buildSummary();
      });

      // Pills inside the help modals pick a value in the configurator, so the modal
      // doubles as a picker (dimensions / headboard height).
      document
        .querySelectorAll("[data-configurator-tabs]")
        .forEach((tabs) => {
          const handle = tabs.dataset.configuratorTabs;

          tabs.querySelectorAll("[data-configurator-tab-value]").forEach((tab) => {
            tab.addEventListener("click", () => {
              const step = this.content?.querySelector(
                `.product-configurator__step[data-option-handle="${CSS.escape(handle)}"]`,
              );
              const card = step?.querySelector(
                `.product-configurator__option[data-value="${CSS.escape(tab.dataset.configuratorTabValue)}"]`,
              );

              if (!card) return;

              this.onOptionClick(card);
              tabs
                .querySelectorAll("[data-configurator-tab-value]")
                .forEach((t) => t.classList.remove("configurator-modal__tab--active"));
              tab.classList.add("configurator-modal__tab--active");
            });
          });
        });

      this.updateShowMore();

      // Wire up add-to-cart button
      if (this.footerSubmit) {
        this.footerSubmit.addEventListener("click", () => {
          this.addToCart();
        });
      }

      // Listen for variant changes from the form (e.g. swatch change) to update the header summary
      window.addEventListener("variantChange", () => {
        this.updatePrices();
      });

      // Handle browser back/forward after pushState navigations
      // Full reload is the most reliable way to restore correct product state
      this._popstateHandler = () => {
        if (window.__drawerHandledPopstate) return;
        window.location.reload();
      };
      window.addEventListener("popstate", this._popstateHandler);
    }

    /**
     * Show the "Zobacz wiecej" button only when a collapsed grid actually hides cards.
     */
    updateShowMore() {
      if (!this.content) return;

      // Szesc kart na kazdej szerokosci - mobilny projekt (Figma 110:1211) pokazuje
      // dokladnie tyle samo co desktop, a nie cztery.
      const limit = 6;

      this.content.querySelectorAll("[data-showmore-grid]").forEach((grid) => {
        const button = grid
          .closest(".product-configurator__section")
          ?.querySelector("[data-showmore]");

        const collapsed = grid.classList.contains("is-collapsed");
        let shown = 0;

        // Liczymy KARTY, nie dzieci siatki. Rodziny premium siedza w jednym bloku
        // wypuszczonym do siatki przez `display: contents`, wiec jako dziecko liczyly
        // sie raz - limit nigdy nie byl przekraczany, "Zobacz wiecej" sie nie pokazywal
        // i lista szla caloscia, choc projekt pokazuje szesc kart.
        const karty = grid.querySelectorAll("[data-fabric-card]");
        const doPoliczenia = karty.length ? Array.from(karty) : Array.from(grid.children);

        // Karty tkanin sa przestawiane WLASCIWOSCIA `order` (sortowanie i domyslna
        // kolejnosc "wybrana, potem te z ikonami"), a nie przenoszeniem w dokumencie.
        // Limit musi wiec liczyc w kolejnosci EKRANOWEJ - inaczej chowal karte ostatnia
        // w dokumencie, choc na ekranie stala w pierwszej szostce. Sortowanie jest
        // stabilne, wiec siatki bez `order` (materace) zostaja przy kolejnosci z DOM.
        doPoliczenia.sort((a, b) => {
          return (parseInt(a.style.order || "0", 10) - parseInt(b.style.order || "0", 10));
        });

        doPoliczenia.forEach((card) => {
          card.classList.remove("is-beyond-limit");

          // Mattress cards not matching the picked size are hidden by the filter, so the
          // limit has to count what is actually on screen, not the DOM position.
          if (card.style.display === "none" || card.hidden) return;

          shown += 1;
          if (collapsed && shown > limit) card.classList.add("is-beyond-limit");
        });

        if (button) button.hidden = !collapsed || shown <= limit;
      });
    }

    /**
     * Fill the shared "option details" modal from the card's own template. Nothing is
     * fetched and nothing is written twice - the card already carries the metaobject data.
     */
    openOptionDetails(card) {
      const template = card?.querySelector("[data-option-details-content]");
      const drawer = document.getElementById("drawer-option-details");
      const body = drawer?.querySelector("[data-option-details-body]");

      if (!template || !body) return;

      body.replaceChildren(template.content.cloneNode(true));

      window.dispatchEvent(
        new CustomEvent("drawerOpen", { detail: { id: "drawer-option-details" } }),
      );
    }

    /**
     * Adres widoku pomocniczego z sekcjami opisu materaca (warstwy, 7 stref,
     * wlasciwosci). Widok ma wlasny layout bez naglowka i stopki sklepu.
     */
    mattressDetailsUrl(url) {
      return url + (url.includes("?") ? "&" : "?") + "view=mattress-details";
    }

    /**
     * Pobiera opis materaca do pamieci, nie ruszajac szuflady. Wolane przy najechaniu
     * na karte i po otwarciu konfiguratora, zeby klikniecie "pelen opis" nie czekalo
     * na siec. Kazdy materac pobierany jest najwyzej raz na odsłone strony.
     */
    prefetchMattressDetails(url) {
      if (!url) return Promise.resolve(null);

      this._mattressCache = this._mattressCache || new Map();
      if (this._mattressCache.has(url)) return this._mattressCache.get(url);

      const request = fetch(this.mattressDetailsUrl(url))
        .then((res) => {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          return doc.querySelectorAll(".pdp-block");
        })
        .catch((err) => {
          // Nieudane dogrzanie nie moze zostac w pamieci jako pustka - inaczej
          // klikniecie "pelen opis" pokazalo by puste okno bez ponowienia.
          this._mattressCache.delete(url);
          throw err;
        });

      this._mattressCache.set(url, request);
      return request;
    }

    /**
     * Fill the "Opis materaca" drawer (Figma 1:6449) with the mattress description
     * sections from the product itself.
     *
     * Tresc idzie z widoku pomocniczego `?view=mattress-details`, ktory oddaje SAME
     * sekcje opisu. Wczesniej czytany byl glowny akordeon opisu produktu, ale migracja
     * po audycie usunela go ze wszystkich szablonow - szuflada otwierala sie pusta.
     */
    openMattressDetails(url, name) {
      if (!url) return;

      const drawer = document.getElementById("drawer-mattress-details");
      if (!drawer) return;

      const body = drawer.querySelector("[data-mattress-details-body]");
      const title = drawer.querySelector("[data-mattress-details-title]");
      const link = drawer.querySelector("[data-mattress-details-link]");
      const loader = drawer.querySelector(".loader");

      if (title) {
        // Wzorzec tytulu ("Opis materaca __NAME__") idzie z plikow jezykowych przez
        // atrybut, zeby tlumaczenie zostalo w locales, a nie w JavaScripcie.
        const pattern = title.dataset.titlePattern;
        title.textContent = pattern && name ? pattern.replace("__NAME__", name) : name || "";
      }
      if (link) link.href = url;

      window.dispatchEvent(
        new CustomEvent("drawerOpen", { detail: { id: "drawer-mattress-details" } }),
      );

      if (this._mattressDetailsUrl === url) return;

      if (body) body.innerHTML = "";
      if (loader) loader.style.display = "block";

      this.prefetchMattressDetails(url)
        .then((blocks) => {
          if (body && blocks && blocks.length) {
            blocks.forEach((block) => body.appendChild(block.cloneNode(true)));
            this._mattressDetailsUrl = url;
          }

          if (loader) loader.style.display = "none";
          drawer.dispatchEvent(new CustomEvent("drawerResize"));
        })
        .catch((err) => {
          if (loader) loader.style.display = "none";
          console.error("Error loading mattress description:", err);
        });
    }

    /**
     * Fill the "Podsumowanie konfiguracji" modal: one group per configurator section,
     * one row per option with its surcharge, then the total from the bottom bar.
     */
    buildSummary() {
      const list = document.querySelector("[data-summary-list]");
      const total = document.querySelector("[data-summary-total]");

      if (!list || !this.content) return;

      list.innerHTML = "";

      const groups = new Map();

      this.content
        .querySelectorAll(".product-configurator__step")
        .forEach((step) => {
          const section = step.closest(".product-configurator__section");
          const sectionTitle = section
            ?.querySelector(".product-configurator__section-title")
            ?.textContent.replace(/^\s*\d+\.?\s*/, "")
            .trim();

          if (!sectionTitle) return;

          const active =
            step.querySelector(".product-configurator__option--active") ||
            step.querySelector(".product-configurator__option:has(input:checked)");

          if (!active) return;

          const label = step.dataset.summaryLabel || sectionTitle;
          const value =
            active.querySelector(".product-configurator__option-value")?.textContent.trim() ||
            active.querySelector(".product-configurator__media-card-title")?.textContent.trim() ||
            active.querySelector(".product-configurator__option-title")?.textContent.trim() ||
            active.dataset.value ||
            "";
          // Karta materaca z rabatem niesie DWIE kwoty (przekreslona i po rabacie).
          // Podsumowanie i suma na dole licza te PO RABACIE (decyzja usera 3 wrz 2026) -
          // tyle wyjdzie w koszyku, wiec suma ma sie z nim zgadzac.
          const mattressFinal = active.querySelector("[data-mattress-price-final]");
          const price = mattressFinal
            ? mattressFinal.textContent.trim()
            : active.querySelector("[data-option-price], [data-option-price-badge], .product-configurator__media-card-price, [data-mattress-price], [data-surcharge-price-display]")
                ?.textContent.trim() || "";

          if (!value) return;

          if (!groups.has(sectionTitle)) groups.set(sectionTitle, []);
          groups.get(sectionTitle).push({ label, value, price });
        });

      groups.forEach((rows, title) => {
        const group = document.createElement("div");
        group.className = "configurator-summary__group";
        group.innerHTML = `
          <p class="configurator-summary__group-title">
            <span class="configurator-summary__check" aria-hidden="true"></span>
            <span>${title}</span>
          </p>
        `;

        rows.forEach((row) => {
          const item = document.createElement("p");
          item.className = "configurator-summary__row";
          item.innerHTML = `
            <span class="configurator-summary__label">${row.label}:</span>
            <span class="configurator-summary__value">${row.value}</span>
            <span class="configurator-summary__price">${row.price}</span>
          `;
          group.appendChild(item);
        });

        list.appendChild(group);
      });

      if (total) total.textContent = this.footerPrice?.textContent.trim() || "";
    }

    onDrawerOpen() {
      this.syncActiveStates();
      this.syncSurchargeProductStates();
      this.filterMattresses();
      this.updatePrices();
      this.updateFooter();
      this.updateShowMore();
      this.loader.style.display = "none";

      // Save reference to original (base) swatch step HTML
      if (!this._baseSwatchHTML) {
        const swatchStep = this.content.querySelector('.product-configurator__step--swatches');
        if (swatchStep) {
          this._baseSwatchHTML = swatchStep.outerHTML;
        }
      }
    }

    /**
     * Handle clicking an option label in the configurator.
     */
    /**
     * Klikniecie w karte tkaniny bazowej wybiera te rodzine: bierzemy odcien juz
     * zaznaczony, a gdy zadnego nie ma - pierwszy z listy. Pomijamy klikniecia,
     * ktore maja wlasna obsluge (odcien, "Zmien", "pelen opis"), zeby nie robic
     * roboty dwa razy.
     */
    klikKartyBazowej(event) {
      const karta = event.target.closest("[data-fabric-card]");

      if (!karta) return;

      // Karty premium sa etykietami i maja wlasna sciezke.
      if (karta.classList.contains("product-configurator__option--fabric-family-card")) return;

      if (
        event.target.closest("[data-family-colors]") ||
        event.target.closest("[data-family-toggle]") ||
        event.target.closest('[aria-controls="drawer-fabric-details"]')
      ) {
        return;
      }

      // Juz wybrana - nie ma czego przestawiac.
      if (karta.classList.contains("product-configurator__fabric-card--active")) return;

      const odcienie = Array.from(
        karta.querySelectorAll("[data-family-colors] .product-configurator__option--swatch"),
      );

      if (!odcienie.length) return;

      const wybrany =
        odcienie.find((el) => el.querySelector('input[type="radio"]')?.checked) || odcienie[0];

      this._wyborAutomatyczny = true;
      this.onOptionClick(wybrany);
      this._wyborAutomatyczny = false;
    }

    /* Ustawiane w fazie przechwytywania, zanim zadziala obsluga etykiety.

       Dotyczy tez "pelnego opisu" na karcie stelaza (`data-option-details`): ten
       przycisk lezy w karcie, a karta jest opcja produktu, wiec jego klikniecie
       przestawialo stelaz. Zmiana stelaza laduje INNY produkt, wiec okno z opisem
       otwieralo sie i zaraz znikalo razem z podmieniona trescia.

       Karta rodziny premium jest ETYKIETA, wiec klikniecie czegokolwiek w jej srodku
       przestawia wybor rodziny i przebudowuje karte. Trzy miejsca musza byc z tego
       wylaczone: "pelen opis" (otwiera szuflade), "Zmien" (rozwija liste odcieni) oraz
       sama lista odcieni - kazde z nich ma wlasna obsluge. Bez tego lista otwierala sie
       i natychmiast znikala, a wybrany odcien wracal do pierwszego z brzegu. */
    oznaczKlikOpisu(event) {
      // Straznik dotyczy WYLACZNIE kart rodzin premium. Karta bazowa nie jest
      // `.product-configurator__option`, wiec jej kafle odcieni ida normalna droga
      // przez `onOptionClick` - to ona przestawia wariant produktu. Objecie ich
      // straznikiem sprawialo, ze wybor odcienia tkaniny bazowej nie robil nic.
      const kartaPremium = event.target.closest(
        ".product-configurator__option--fabric-family-card",
      );

      if (
        event.target.closest("[data-option-details]") ||
        event.target.closest('[aria-controls="drawer-fabric-details"]') ||
        (kartaPremium &&
          (event.target.closest("[data-family-toggle]") ||
            event.target.closest("[data-family-colors]")))
      ) {
        this._klikOpisu = true;
      }
    }

    onOptionClick(label) {
      const input = label.querySelector('input[type="radio"]');
      if (input?.disabled) {
        return;
      }

      const step = label.closest(".product-configurator__step");
      const optionIndex = parseInt(step.dataset.optionIndex, 10);
      const optionHandle = step.dataset.optionHandle;
      const value = label.dataset.value;

      if (label.dataset.swatchSurcharge === "true") {
        this.setActiveOption(step, label);
        this.onSurchargeProductChange(`swatch-${optionHandle}`, label);
        this.updateFooter();
        return;
      }

      if (step.classList.contains("product-configurator__step--swatches")) {
        this._surchargeData[`swatch-${optionHandle}`] = {
          active: false,
          selectedVariantId: null,
          title: '',
          price: 0,
          priceFormatted: '',
          propertyName: '',
        };
      }

      // Handle additional options that require navigating to a different product
      if (label.dataset.url) {
        if (this.productForm && this.productForm.selected_values) {
          localStorage.setItem(
            "pdp_selected_values",
            JSON.stringify(this.productForm.selected_values),
          );
        }

        // Show loader inside the drawer
        if (this.loader) this.loader.style.display = "block";

        this.isNavigating = true;

        const adres = this.adresZParametramiPodgladu(label.dataset.url);

        // Push new URL into history BEFORE fetching
        window.history.pushState(
          { configuratorNav: true, url: adres },
          "",
          adres,
        );

        this.reloadProductSection(adres);
        return;
      }

      // Find the corresponding hidden product-option in the product form
      const productOption = this.productForm.querySelector(
        `product-option[data-handle="${optionHandle}"]`,
      );

      if (productOption) {
        // Check the matching radio in the product form
        const radio = productOption.querySelector(
          `input[type="radio"][value="${CSS.escape(value)}"]`,
        );
        if (radio) {
          radio.checked = true;
        } else {
          // If no radio, we might be dealing with an additional option
          const hiddenInput = productOption.parentElement?.querySelector(
            'input[type="hidden"][name^="properties["]',
          );
          if (hiddenInput) {
            hiddenInput.value = value;
          }
        }

        // Visually update the label and button values in the product form
        const labelText = productOption.querySelector(".product-option__label");
        if (labelText) {
          labelText.innerText = value;
        }
        const dropdownBtnText = productOption.querySelector(
          ".product-option__dropdown-btn > span:first-child",
        );
        if (dropdownBtnText) {
          dropdownBtnText.innerText = value;
        }

        // Update data-value and dispatch valueChange
        productOption.setAttribute("data-value", value);
        productOption.dispatchEvent(new CustomEvent("valueChange"));
      }

      // Update visual active state in this step
      this.setActiveOption(step, label);

      // Re-filter mattresses when sleeping surface size changes
      if (optionHandle === this.dataset.bedSizeHandle) {
        this.filterMattresses();
      }

      // Handle generic surcharge-product steps (headboard, etc.)
      if (this.isSurchargeProductStep(optionHandle)) {
        this.onSurchargeProductChange(optionHandle, label);
        this.updateFooter();
        return;
      }

      // "Pelen opis" lezy W SRODKU karty, a karta premium jest etykieta. Bez tego
      // strazniku otwarcie szuflady z opisem przy okazji przestawialoby wybrana
      // rodzine tkanin.
      if (this._klikOpisu) {
        this._klikOpisu = false;
        return;
      }

      // Wybor tkaniny BAZOWEJ konczy wybor rodziny premium. Bez tego po wybraniu
      // premium i kliknieciu z powrotem w karte bazowa obie zostawaly zaznaczone,
      // a do koszyka szedl produkt doplatowy, ktorego klient juz nie chcial.
      if (
        optionHandle !== 'fabric-family' &&
        this._fabricFamilyActive &&
        label.closest('.product-configurator__step--swatches') &&
        !label.closest('.product-configurator__step--fabric-family')
      ) {
        this.odznaczRodzinePremium();
      }

      // Obwodka idzie za wybrana tkanina takze na kartach BAZOWYCH. Zaznaczenie
      // rysuje Liquid przy renderowaniu strony, a zmiana wariantu dzieje sie po
      // stronie przegladarki (bez przeladowania sekcji) - bez tego po powrocie z
      // rodziny premium zadna karta nie byla zaznaczona.
      const kartaTkaniny = label.closest('[data-fabric-card]');

      if (kartaTkaniny && label.closest('.product-configurator__step--swatches')) {
        this.content
          .querySelectorAll('.product-configurator__fabric-card--active')
          .forEach((el) => el.classList.remove('product-configurator__fabric-card--active'));
        kartaTkaniny.classList.add('product-configurator__fabric-card--active');

        const nazwaEl = kartaTkaniny.querySelector('.product-configurator__color-name');
        const chipEl = kartaTkaniny.querySelector('.product-configurator__color-chip');
        const obraz = label.querySelector('img');

        if (nazwaEl) {
          let etykieta = label.dataset.value || '';

          try {
            const mapEl = document.querySelector('[data-color-names]');

            if (mapEl) {
              const map = JSON.parse(mapEl.textContent || '{}');
              if (map[etykieta]) etykieta = map[etykieta];
            }
          } catch (e) {
            // Zla mapa nie moze wywrocic wyboru tkaniny - zostaje kod odcienia.
          }

          nazwaEl.textContent = 'Kolor: ' + etykieta;
        }

        if (chipEl && obraz) chipEl.style.backgroundImage = 'url("' + obraz.src + '")';

        // Zdjecie karty idzie za odcieniem TYLKO wtedy, gdy klient sam kliknal w kolor.
        // Samo wejscie w rodzine (klikniecie karty) zostawia grafike taka, jaka jest -
        // to recznie dobrane zdjecie okladkowe rodziny, a nie podglad odcienia.
        if (!this._wyborAutomatyczny) {
          const zdjecieKarty = kartaTkaniny.querySelector(
            ".product-configurator__fabric-card-media img",
          );

          if (zdjecieKarty && obraz) zdjecieKarty.src = obraz.src;
        }
      }

      // Handle fabric family selection — reload swatches from surcharge product
      if (optionHandle === 'fabric-family') {
        this.onFabricFamilyChange(label);
        // Fabric family doesn't change the base variant — only update the footer
        this.updateFooter();
        return;
      }

      // Update prices and footer after variant change
      setTimeout(() => {
        this.updatePrices();
        this.updateFooter();
      }, 100);
    }

    /**
     * Update the visual active state: toggle classes and checkbox SVGs.
     */
    setActiveOption(step, activeLabel) {
      step.querySelectorAll(".product-configurator__option").forEach((item) => {
        item.classList.remove("product-configurator__option--active");

        // Uncheck the radio inside
        const radio = item.querySelector('input[type="radio"]');
        if (radio) radio.checked = false;
      });

      activeLabel.classList.add("product-configurator__option--active");

      // Check the radio inside
      const radio = activeLabel.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    }

    /**
     * Sync the configurator UI to match the current product form state.
     * This reads which radio is checked in each hidden product-option
     * and activates the corresponding label in the configurator.
     */
    syncActiveStates() {
      this.content
        .querySelectorAll(".product-configurator__step")
        .forEach((step) => {
          const optionHandle = step.dataset.optionHandle;
          const productOption = this.productForm?.querySelector(
            `product-option[data-handle="${optionHandle}"]`,
          );

          if (!productOption) return;

          const checkedRadio = productOption.querySelector(
            'input[type="radio"]:checked',
          );
          const currentValue = checkedRadio
            ? checkedRadio.value
            : productOption.dataset.value || "";

          if (currentValue) {
            const matchingLabel = step.querySelector(
              `.product-configurator__option[data-value="${CSS.escape(currentValue)}"]`,
            );
            if (matchingLabel) {
              this.setActiveOption(step, matchingLabel);
            }
          }
        });
    }

    /**
     * Update prices on each option by fetching the main-product section natively.
     */
    updatePrices() {
      // Debounce: if called multiple times within 150ms, only the last call fires
      clearTimeout(this._updatePricesTimer);
      this._updatePricesTimer = setTimeout(() => this._updatePricesNow(), 150);
    }

    _updatePricesNow() {
      if (!this.productForm || !this.content || this.isNavigating) return;

      const variantSelect = this.productForm.querySelector('select[name="id"]');
      if (!variantSelect) return;

      const currentVariantId = variantSelect.value;

      const section =
        this.closest(".shopify-section") ||
        document.querySelector(".section--pdp")?.closest(".shopify-section");
      const sectionId = section
        ? section.id.replace("shopify-section-", "")
        : "";
      const url = sectionId
        ? `${window.location.pathname}?variant=${currentVariantId}&section_id=${sectionId}`
        : `${window.location.pathname}?variant=${currentVariantId}`;

      // Ensure previous fetch token is cleared
      const token = Symbol();
      this.currentFetchToken = token;

      // To samo zapytanie co ostatnio - nie ma czego odswiezac. Przy zmianie stelaza
      // (osobny produkt, czyli pelna nawigacja) ta funkcja odpalala sie dwa razy pod
      // rzad z tym samym adresem i serwer renderowal cala sekcje dwukrotnie: 1248 ms
      // + 1301 ms zmarnowane, w dodatku rownolegle ze zdjeciem galerii.
      if (ostatniAdresCen === url) return;

      ostatniAdresCen = url;

      // Poprzednie, juz nieaktualne przerenderowanie przerywamy. Sam token tylko
      // IGNOROWAL odpowiedz - polaczenie i praca serwera trwaly dalej i opoznialy
      // zapytanie o zdjecie, ktore leci w tym samym momencie.
      if (this._przerwijCeny) this._przerwijCeny.abort();

      const kontroler = new AbortController();
      this._przerwijCeny = kontroler;

      fetch(url, { signal: kontroler.signal })
        .then((res) => {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.text();
        })
        .then((html) => {
          if (this.currentFetchToken !== token) return;

          const doc = new DOMParser().parseFromString(html, "text/html");

          // Update price placeholders with fresh server-rendered ones
          const fetchedPrices = Array.from(
            doc.querySelectorAll(
              "#drawer-product-configurator [data-option-price]",
            ),
          );
          const currentPrices = Array.from(
            this.content.querySelectorAll("[data-option-price]"),
          );
          const currentPricesByKey = new Map(
            currentPrices.map((el, index) => [
              el.dataset.optionPriceKey || `__index_${index}`,
              el,
            ]),
          );

          fetchedPrices.forEach((newEl, index) => {
            const key = newEl.dataset.optionPriceKey || `__index_${index}`;
            const currentEl = currentPricesByKey.get(key);

            if (currentEl) {
              currentEl.innerHTML = newEl.innerHTML;
            }
          });

          // The dimensions table in the help modal is rendered per variant, so it has to
          // travel with the same fetch - otherwise it keeps showing the previous size.
          const fetchedSpecs = doc.querySelector("[data-configurator-specs]");
          const currentSpecs = document.querySelector("[data-configurator-specs]");
          if (fetchedSpecs && currentSpecs) {
            currentSpecs.innerHTML = fetchedSpecs.innerHTML;
          }

          // Update footer price naturally
          const fetchedFooterPrice = doc.querySelector("[data-footer-price]");
          if (this.footerPrice) {
            if (fetchedFooterPrice) {
              this.footerPrice.innerHTML = fetchedFooterPrice.innerHTML;
            }
            this.footerPrice.classList.remove("loading");
          }

          // Update selected options summary
          const fetchedSummary = doc.querySelector(".product__selected-options");
          const currentSummary = document.querySelector(
            ".product__selected-options",
          );
          if (fetchedSummary && currentSummary) {
            currentSummary.innerHTML = fetchedSummary.innerHTML;
            this.bindFabricDetailsButtons(currentSummary);
          }

          // Recalculate footer to include mattress surcharge
          this.updateFooter();
        })
        .catch((err) => {
          // Przerwane zapytanie to NASZA decyzja, nie awaria - nie zglaszamy go
          // i nie kasujemy adresu, bo zaraz leci nowsze.
          if (err && err.name === "AbortError") return;

          // Po bledzie adres trzeba zapomniec, inaczej ponowna proba z tym samym
          // wyborem zostalaby uznana za powtorke i cena nigdy by sie nie odswiezyla.
          ostatniAdresCen = null;

          if (this.currentFetchToken !== token) return;
          if (this.footerPrice) this.footerPrice.classList.remove("loading");
          console.error(
            "Error fetching configurator prices via Section Rendering API",
            err,
          );
        });
    }

    getActiveMattressCard() {
      if (!this.content) return null;

      return Array.from(
        this.content.querySelectorAll(
          '.product-configurator__step--mattress .product-configurator__option--mattress-card',
        ),
      ).find((card) => {
        const radio = card.querySelector('input[type="radio"]:checked');
        return radio && card.style.display !== "none";
      }) || null;
    }

    getSelectedMattress() {
      const activeCard = this.getActiveMattressCard();
      if (!activeCard) return null;

      const radio = activeCard.querySelector('input[type="radio"]');
      if (!radio || !radio.value) return null;

      // Przy rabacie karta pokazuje dwie kwoty - pasek na dole i podsumowanie
      // biora te PO RABACIE (patrz komentarz w podsumowaniu wyzej).
      const priceFinalEl = activeCard.querySelector("[data-mattress-price-final]");
      const priceEl = activeCard.querySelector("[data-mattress-price]");
      const title = activeCard.dataset.mattressTitle || "";

      let price = 0;
      try {
        const variants = JSON.parse(activeCard.dataset.mattressVariants || "[]");
        const match = variants.find((v) => String(v.id) === String(radio.value));
        if (match) price = match.price;

        // Rabat schodzi w koszyku, ale suma w pasku ma pokazywac to, co kupujacy
        // faktycznie zaplaci. Zaokraglenie do pelnych zlotych jest takie samo jak
        // przy kwocie na karcie - inaczej suma nie zgadzalaby sie z widocznymi cenami.
        const rabat = parseFloat(priceEl?.dataset.mattressDiscount || "0") || 0;
        if (rabat > 0) {
          price = Math.round((price * (100 - rabat)) / 100 / 100) * 100;
        }
      } catch (e) {
        console.error(
          `Error parsing price from variants JSON for mattress: ${e.message}`,
          e,
        );
      }

      return {
        variantId: radio.value,
        title,
        price,
        priceFormatted: priceFinalEl
          ? priceFinalEl.textContent.trim()
          : priceEl
            ? priceEl.textContent.trim()
            : "",
      };
    }

    /**
     * Get the currently selected fabric family card (if any premium family is checked).
     */
    getActiveFabricFamilyCard() {
      if (!this.content) return null;
      return Array.from(
        this.content.querySelectorAll(
          '.product-configurator__step--fabric-family .product-configurator__option--fabric-family-card',
        ),
      ).find((card) => {
        const radio = card.querySelector('input[type="radio"]:checked');
        return !!radio;
      }) || null;
    }

    /**
     * Zdejmuje wybor rodziny premium: listy odcieni, obwodki i zaznaczone radia.
     * Wolane i przy powrocie na tkanine bazowa, i przy kliknieciu w karte bazowa -
     * bez tego dwie karty zostawaly zaznaczone naraz.
     */
    odznaczRodzinePremium() {
      this.content
        .querySelectorAll('[data-fabric-family-colors]')
        .forEach((el) => el.remove());

      this.content
        .querySelectorAll('.product-configurator__option--fabric-family-card')
        .forEach((el) => {
          el.classList.remove('product-configurator__fabric-card--active');
          el.classList.remove('product-configurator__option--active');
          const r = el.querySelector('input[type="radio"][name="fabric-family"]');
          if (r) r.checked = false;
        });

      const bazowe = this.content.querySelector('#fabric-family-none');
      if (bazowe) bazowe.checked = true;

      this._fabricFamilyActive = false;
      this._fabricFamilySelectedVariantId = null;
    }

    /**
     * Get the selected fabric family surcharge info.
     * Returns null if "Base fabric" is selected (no surcharge).
     * The variant for the cart comes from the swatch step's currently checked radio
     * (which shows the surcharge product's color variants after family change).
     */
    getSelectedFabricFamily() {
      const activeCard = this.getActiveFabricFamilyCard();
      if (!activeCard) return null;

      const title = activeCard.dataset.fabricFamilyTitle || "";
      const price = parseInt(activeCard.dataset.fabricFamilyPrice || "0", 10);
      const priceEl = activeCard.querySelector("[data-fabric-family-price-display]");

      // The variant ID comes from the selected color in the swatch step
      // which now shows the surcharge product's variants
      const variantId = this._fabricFamilySelectedVariantId || "";

      if (!variantId) return null;

      /* Nazwa wybranego koloru premium (np. "Muso 07") - potrzebna, zeby
         pozycja lozka w koszyku pokazywala wybrana tkanine, a nie bazowa. */
      const wariant = (this._fabricFamilyVariants || []).find(
        (v) => String(v.id) === String(variantId),
      );

      return {
        variantId,
        title,
        price,
        colorValue: wariant ? wariant.options[0] || wariant.title : "",
        priceFormatted: priceEl ? priceEl.textContent.trim() : "",
      };
    }

    /**
     * Handle fabric family selection.
     * When a premium family is selected, fetch the surcharge product's page
     * and replace the swatch step with its color swatches.
     * When "base fabric" is selected, restore the original swatch step.
     */
    /* Podmiana kroku tkanin zmienia wysokosc tresci LEZACEJ WYZEJ niz klikana
       karta rodziny (krok swatchy stoi w panelu przed krokiem rodzin), wiec po
       wyborze rodziny cala tresc pod spodem przeskakuje - zmierzone 429 px
       przy przejsciu na rodzine premium i 93 px przy zmianie rodziny.

       Dlatego kotwiczymy na KLIKANYM elemencie: zapisujemy jego przesuniecie
       wzgledem gornej krawedzi kadru i po podmianie ustawiamy przewiniecie tak,
       zeby wrocil na to samo miejsce. To ten sam pomysl, co kotwica na kroku
       przy przebudowie calej sekcji - tylko punktem odniesienia jest element,
       na ktory uzytkownik wlasnie patrzy. */
    zapiszKotwice(el) {
      const scroller =
        this.content?.closest(".drawer__scroll") || this.content?.parentElement;

      if (!scroller || !el) return null;

      return {
        scroller,
        el,
        offset:
          el.getBoundingClientRect().top - scroller.getBoundingClientRect().top,
      };
    }

    przywrocKotwice(kotwica) {
      if (!kotwica) return;

      const { scroller, el, offset } = kotwica;
      const drawerEl = this.closest("drawer-section");

      /* Ponawiamy przez ~1 s: perfect-scrollbar przelicza sie po podmianie, a
         zdjecia swatchy doczytuja sie jeszcze kilka klatek pozniej i znowu
         zmieniaja wysokosc tresci.

         ALE korekta MUSI ustapic uzytkownikowi: kto zaraz po wyborze zaczyna
         przewijac, byl przez te sekunde sciagany z powrotem (zgloszone
         26 sie 2026: "jak zaznacze i zaczynam scrolowac to mnie przytrzymuje").
         Pierwszy ruch kolka, palca albo klawisza konczy poprawianie.

         Sygnalem NIE MOZE byc zdarzenie `scroll` - wywoluje je takze nasze
         wlasne ustawienie pozycji, wiec korekta anulowalaby sama siebie. */
      const timery = [];
      let czynne = true;

      const przerwij = () => {
        if (!czynne) return;

        czynne = false;
        timery.forEach((t) => window.clearTimeout(t));
        ["wheel", "touchstart", "touchmove", "keydown"].forEach((zdarzenie) => {
          scroller.removeEventListener(zdarzenie, przerwij);
          window.removeEventListener(zdarzenie, przerwij);
        });
      };

      ["wheel", "touchstart", "touchmove", "keydown"].forEach((zdarzenie) => {
        scroller.addEventListener(zdarzenie, przerwij, { passive: true });
        window.addEventListener(zdarzenie, przerwij, { passive: true });
      });

      const przywroc = () => {
        if (!czynne || !el.isConnected) return;

        if (drawerEl && drawerEl.scrollbars) {
          drawerEl.scrollbars.forEach((sb) => sb.update());
        }

        const cel = Math.max(
          0,
          Math.round(
            scroller.scrollTop +
              el.getBoundingClientRect().top -
              scroller.getBoundingClientRect().top -
              offset,
          ),
        );

        if (Math.abs(scroller.scrollTop - cel) > 1) scroller.scrollTop = cel;
      };

      przywroc();
      requestAnimationFrame(przywroc);
      [80, 200, 400, 700, 1000].forEach((ms) =>
        timery.push(window.setTimeout(przywroc, ms)),
      );
      timery.push(window.setTimeout(przerwij, 1100));
    }

    onFabricFamilyChange(label) {
      const radio = label.querySelector('input[type="radio"]');
      const radioValue = radio ? radio.value : "";

      // Zaznaczenie radia rodziny MUSI byc zrobione recznie. Obsluga klikniec wola
      // preventDefault(), wiec etykieta nie zaznacza swojego radia sama, a od tego
      // zaznaczenia zalezy getActiveFabricFamilyCard() - czyli to, czy produkt
      // doplatowy w ogole trafi do koszyka.
      if (radio) {
        const block = label.closest(".product-configurator__step--fabric-family");

        if (block) {
          block.querySelectorAll('input[type="radio"][name="fabric-family"]').forEach((other) => {
            other.checked = false;
          });
          block.querySelectorAll(".product-configurator__option").forEach((option) => {
            option.classList.remove("product-configurator__option--active");
          });
        }

        radio.checked = true;

        const card = label.closest(".product-configurator__option");
        if (card) card.classList.add("product-configurator__option--active");
      }

      const swatchStep = this.content.querySelector('.product-configurator__step--swatches');
      if (!swatchStep) return;

      const kotwica = this.zapiszKotwice(
        label.closest(".product-configurator__option") || label,
      );

      // Powrot na tkanine bazowa: siatka nigdy nie znika, wiec nie ma czego
      // odtwarzac. Wystarczy zdjac liste odcieni wstrzyknieta w karte premium i
      // oddac obwodke karcie bazowej wybranego wariantu. Wczesniej ta galaz
      // podmieniala CALY krok tkanin z zapamietanego HTML - a to gubilo stan
      // filtrow i sortowania, bo HTML pochodzil sprzed ich uzycia.
      if (!radioValue) {
        this._fabricFamilyActive = false;
        this._fabricFamilySelectedVariantId = null;
        this.odznaczRodzinePremium();
        this.przywrocKotwice(kotwica);
        return;
      }

      // Premium family selected — find the surcharge product URL
      const card = label.closest('.product-configurator__option--fabric-family-card');
      if (!card) return;

      // Klikniecie w JUZ WYBRANA rodzine nie przebudowuje kroku. Etykieta potrafi
      // zglosic drugie, syntetyczne klikniecie (label -> input), a rownolegle dwa
      // fetch'e konczyly sie zdublowana lista odcieni i drugim paskiem koloru.
      if (
        card.classList.contains('product-configurator__fabric-card--active') &&
        card.querySelector('[data-family-colors]')
      ) {
        this.przywrocKotwice(kotwica);
        return;
      }

      const productUrl = card.dataset.fabricFamilyProductUrl;
      if (!productUrl) return;

      this._fabricFamilyActive = true;
      this._fabricFamilySelectedVariantId = null;

      // Fetch the surcharge product data via Shopify .js endpoint
      fetch(productUrl + '.js')
        .then((res) => {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then((productData) => {
          // .js endpoint returns the product object directly (no wrapper)
          if (productData && productData.variants) {
            this._fabricFamilyVariants = productData.variants.map((v) => ({
              id: v.id,
              title: v.title,
              price: v.price,
              options: [v.option1, v.option2, v.option3].filter(Boolean),
              image: v.featured_image ? v.featured_image.src : null,
            }));
          } else {
            this._fabricFamilyVariants = [];
          }

          // Karty rodzin premium zostaja W SIATCE razem z bazowymi (Figma 110:632):
          // projekt pokazuje JEDEN zestaw jednakowych kart. Wczesniej wybor rodziny
          // premium usuwal wszystkie grupy swatchy i zostawial jedna, inaczej
          // zbudowana karte - stad "reszta kart wyglada inaczej niz pierwsza tkanina",
          // a jedyna droga powrotna do tkaniny bazowej wiodla przez osobny wiersz
          // wcisniety miedzy karty.
          //
          // Teraz karta premium dostaje po prostu to, co maja karty bazowe: pasek
          // koloru i zwinieta liste odcieni.
          const wzorzecCheckbox = this.content.querySelector('.product-configurator__swatch-checkbox');
          const checkboxSvg = wzorzecCheckbox ? wzorzecCheckbox.innerHTML : '';
          const wzorzecZmien = this.content.querySelector('[data-family-toggle]');
          const napisZmien = wzorzecZmien ? wzorzecZmien.textContent.trim() : 'Zmień';

          // Listy odcieni wstrzykniete w INNE karty premium znikaja - odcien nalezy
          // do rodziny, wiec dwie otwarte listy naraz nie maja sensu.
          this.content
            .querySelectorAll('[data-fabric-family-colors]')
            .forEach((el) => el.remove());

          // Obwodke przejmuje karta premium; bazowe ja oddaja.
          this.content
            .querySelectorAll('.product-configurator__fabric-card--active')
            .forEach((el) => el.classList.remove('product-configurator__fabric-card--active'));
          card.classList.add('product-configurator__fabric-card--active');

          const cialoKarty = card.querySelector('.product-configurator__fabric-card-body');

          if (!cialoKarty) {
            this.przywrocKotwice(kotwica);
            return;
          }

          // Pasek koloru JEST juz w karcie: Liquid rezerwuje mu miejsce od pierwszego
          // renderu (znika przez visibility na kartach niewybranych), wiec karta nie
          // skacze przy wyborze. Tworzymy go wylacznie AWARYJNIE - gdyby znacznik byl
          // starszy niz ten skrypt. Bezwarunkowe tworzenie zostawialo na karcie DWA
          // paski i podnosilo ja o 38px przy kazdym wejsciu w rodzine.
          let pasekKoloru = cialoKarty.querySelector('.product-configurator__color-bar');

          if (!pasekKoloru) {
            pasekKoloru = document.createElement('div');
            pasekKoloru.className = 'product-configurator__color-bar';
            pasekKoloru.innerHTML = `
              <span class="product-configurator__color-chip" aria-hidden="true"></span>
              <span class="product-configurator__color-name"></span>
              <button type="button" class="product-configurator__color-change" data-family-toggle aria-expanded="false">${napisZmien}</button>
            `;

            // Pasek koloru stoi NAD "pelnym opisem", tak jak na kartach bazowych.
            const stopkaKarty = cialoKarty.querySelector('.product-configurator__fabric-card-foot');

            if (stopkaKarty) {
              cialoKarty.insertBefore(pasekKoloru, stopkaKarty);
            } else {
              cialoKarty.appendChild(pasekKoloru);
            }
          }

          const listaOdcieni = document.createElement('div');
          listaOdcieni.setAttribute('data-fabric-family-colors', '');
          listaOdcieni.className = 'product-configurator__fabric-card-colors';
          listaOdcieni.setAttribute('data-family-colors', '');
          card.appendChild(listaOdcieni);

          const grid = listaOdcieni;

          this._fabricFamilyVariants.forEach((variant) => {
            const value = variant.options[0] || variant.title;
            const imageUrl = variant.image || '';

            const swatch = document.createElement('label');
            swatch.className = 'product-configurator__option product-configurator__option--swatch';
            swatch.dataset.value = value;
            // Ten sam wiersz co na kartach bazowych: probka, numer odcienia i nazwa
            // koloru po ludzku. Nazwa przychodzi z mapy z Liquida, bo warianty produktu
            // doplatowego nios a tylko kod ("Morl 06").
            const numerOdcienia = value.split(' ').pop();
            let nazwaKoloru = '';

            try {
              const mapEl = document.querySelector('[data-color-names]');

              if (mapEl) {
                const map = JSON.parse(mapEl.textContent || '{}');
                nazwaKoloru = map[value] || '';
              }
            } catch (e) {
              // Zla mapa nie moze wywrocic listy odcieni - zostaje sam numer.
            }

            swatch.innerHTML = `
              <input type="radio" name="configurator-surcharge-color" value="${value}">
              <div class="product-configurator__swatch-card">
                <div class="product-configurator__swatch-image-wrapper">
                  ${imageUrl ? `<img src="${imageUrl}" alt="${value}" width="108" height="142" loading="lazy">` : ''}
                  <div class="product-configurator__swatch-checkbox">
                    ${checkboxSvg}
                  </div>
                </div>
                <span class="product-configurator__swatch-compact" aria-hidden="true">
                  <span class="product-configurator__swatch-compact-code">${numerOdcienia}</span>
                  ${nazwaKoloru ? `<span class="product-configurator__swatch-compact-color">${nazwaKoloru}</span>` : ''}
                </span>
                <div class="product-configurator__swatch-info">
                  <span class="product-configurator__option-value">${value}</span>
                </div>
              </div>
            `;
            swatch.title = nazwaKoloru ? `${value} — ${nazwaKoloru}` : value;

            swatch.addEventListener('click', (e) => {
              e.preventDefault();
              this.onFabricFamilySwatchClick(swatchStep, swatch);
            });

            grid.appendChild(swatch);
          });

          // Pierwszy odcien wybiera sie sam - karta nie moze stac z pustym paskiem.
          const pierwszyOdcien = grid.querySelector('.product-configurator__option');

          if (pierwszyOdcien) {
            this._wyborAutomatyczny = true;
            this.onFabricFamilySwatchClick(swatchStep, pierwszyOdcien);
            this._wyborAutomatyczny = false;
          }

          this.przywrocKotwice(kotwica);
        })
        .catch((err) => {
          console.error('Error loading fabric family swatches:', err);
          this.przywrocKotwice(kotwica);
        });
    }

    /**
     * Handle clicking a swatch in the surcharge product's color step.
     * Does NOT update the base product — only tracks the selected variant
     * for add-to-cart and visually toggles active state.
     */
    onFabricFamilySwatchClick(swatchStep, label) {
      // Visual toggle
      //
      // WAZNE: pomijamy karty rodzin tkanin. Blok rodzin lezy od dzis W SRODKU kroku
      // tkanin (wczesniej byl osobnym krokiem), wiec to zapytanie odznaczalo takze
      // radio wybranej rodziny. Skutek: getActiveFabricFamilyCard() nie znajdowal
      // aktywnej karty, getSelectedFabricFamily() zwracal null i produkt doplatowy
      // NIE trafial do koszyka - klient wybieral tkanine, a kupowal wariant bazowy.
      swatchStep.querySelectorAll('.product-configurator__option').forEach((item) => {
        if (item.closest('.product-configurator__step--fabric-family')) return;

        item.classList.remove('product-configurator__option--active');
        const r = item.querySelector('input[type="radio"]');
        if (r) r.checked = false;
      });
      label.classList.add('product-configurator__option--active');

      // Pasek koloru w karcie rodziny: nazwa odcienia i probka. Bez tego karta
      // zbudowana po wybraniu rodziny premium miala pusty pasek.
      const familyCard = label.closest('[data-fabric-card]');
      if (familyCard) {
        const nameEl = familyCard.querySelector('.product-configurator__color-name');
        const chipEl = familyCard.querySelector('.product-configurator__color-chip');
        const img = label.querySelector('img');

        // Ludzka nazwa koloru zamiast kodu odcienia. Mapa przychodzi z Liquida, bo
        // warianty produktu doplatowego nios a tylko kod ("Morl 06").
        let colorLabel = label.dataset.value || '';
        try {
          const mapEl = document.querySelector('[data-color-names]');
          if (mapEl) {
            const map = JSON.parse(mapEl.textContent || '{}');
            if (map[colorLabel]) colorLabel = map[colorLabel];
          }
        } catch (e) {
          // Zla mapa nie moze wywrocic wyboru tkaniny - zostaje kod.
        }

        if (nameEl) nameEl.textContent = 'Kolor: ' + colorLabel;
        if (chipEl && img) chipEl.style.backgroundImage = 'url("' + img.src + '")';

        // Jak wyzej: przy automatycznym zaznaczeniu pierwszego odcienia zostawiamy
        // zdjecie okladkowe rodziny (np. "04-Morl-70.jpg"), bo to ono jest wizytowka
        // karty. Dopiero swiadomy wybor koloru podmienia grafike na ten odcien.
        if (!this._wyborAutomatyczny) {
          const zdjecieKartyPremium = familyCard.querySelector(
            '.product-configurator__fabric-card-media img',
          );

          if (zdjecieKartyPremium && img) zdjecieKartyPremium.src = img.src;
        }

        // Wybor odcienia zamyka liste - karta pokazuje juz nowy kolor.
        const list = familyCard.querySelector('[data-family-colors]');
        const toggle = familyCard.querySelector('[data-family-toggle]');
        if (list) list.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
      const radio = label.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;

      // Track the selected value — we need to find the variant ID
      // from the surcharge product. The swatch uses the option value (e.g. "Haze 03")
      // but we need the variant ID for the cart.
      const value = label.dataset.value || (radio ? radio.value : "");

      // The swatch step may contain a product-form <select> with variant IDs,
      // or we can find the variant from the fetched product data.
      // For simplicity, store the value and resolve the variant ID from the
      // hidden select in the product-form on the surcharge product page.
      // But since we replaced the swatch step with fetched HTML, we need
      // another approach: store variant data from the fetch.

      // Use the variant data we stored during fetch
      if (this._fabricFamilyVariants && value) {
        const matchedVariant = this._fabricFamilyVariants.find((v) =>
          v.options.some((opt) => opt === value)
        );
        if (matchedVariant) {
          this._fabricFamilySelectedVariantId = String(matchedVariant.id);
        }
      }

      this.updateFooter();
    }

    // ──────────────────────────────────────────────────────────
    //  Generic surcharge-product methods
    // ──────────────────────────────────────────────────────────

    /**
     * Check if a step is a generic surcharge-product step.
     */
    isSurchargeProductStep(optionHandle) {
      const step = this.content.querySelector(
        `.product-configurator__step--surcharge-product[data-option-handle="${CSS.escape(optionHandle)}"]`
      );
      return !!step;
    }

    syncSurchargeProductStates() {
      this.content
        .querySelectorAll(".product-configurator__step--surcharge-product")
        .forEach((step) => {
          const optionHandle = step.dataset.optionHandle;
          if (!optionHandle) return;

          let checkedRadio = step.querySelector('input[type="radio"]:checked');
          if (!checkedRadio) {
            checkedRadio = step.querySelector('input[type="radio"]');
            if (checkedRadio) checkedRadio.checked = true;
          }

          const activeOption = checkedRadio?.closest(".product-configurator__option");
          if (!activeOption) return;

          this.setActiveOption(step, activeOption);
          this.onSurchargeProductChange(optionHandle, activeOption);
        });
    }

    /**
     * Handle selecting a surcharge product card.
     * Tracks the selected variant for cart and price display.
     * Does NOT touch the swatch step.
     */
    onSurchargeProductChange(optionHandle, label) {
      const radio = label.querySelector('input[type="radio"]');
      const radioValue = radio ? radio.value : '';

      // If "none / base" selected (empty value), clear surcharge data
      if (!radioValue) {
        this._surchargeData[optionHandle] = {
          active: false,
          selectedVariantId: null,
          title: '',
          price: 0,
          priceFormatted: '',
          propertyName: '',
        };
        return;
      }

      // Surcharge card selected — read data attributes
      const card = label.closest('[data-surcharge-title]');
      if (!card) return;

      const title = card.dataset.surchargeTitle || '';
      const price = parseInt(card.dataset.surchargePrice || '0', 10);
      const variantId = card.dataset.surchargeVariantId || '';
      const priceEl = card.querySelector('[data-surcharge-price-display]');

      this._surchargeData[optionHandle] = {
        active: true,
        selectedVariantId: variantId,
        title,
        price,
        priceFormatted: priceEl ? priceEl.textContent.trim() : '',
        propertyName: card.dataset.surchargePropertyName || '',
      };
    }

    /**
     * Get the selected surcharge product for a given option handle.
     * Returns { variantId, title, price, priceFormatted } or null.
     */
    getSelectedSurchargeProduct(optionHandle) {
      const data = this._surchargeData[optionHandle];
      if (!data || !data.active) return null;
      return {
        variantId: data.selectedVariantId,
        title: data.title,
        price: data.price,
        priceFormatted: data.priceFormatted,
        propertyName: data.propertyName,
      };
    }

    /**
     * Get all selected surcharge products across all generic steps.
     * Returns an array of { optionHandle, variantId, title, price, priceFormatted }.
     */
    getAllSelectedSurchargeProducts() {
      const results = [];
      for (const [handle, data] of Object.entries(this._surchargeData)) {
        const selected = this.getSelectedSurchargeProduct(handle);
        if (selected) {
          results.push({ optionHandle: handle, ...selected });
        }
      }
      return results;
    }


    /**
     * Update the floating summary footer with current price and selected params.
     */
    updateFooter() {
      if (!this.footer || !this.productForm) return;

      const allOptions = this.productForm.querySelectorAll("product-option");
      const variantSelect = this.productForm.querySelector('select[name="id"]');

      if (!variantSelect) return;

      const currentVariantId = variantSelect.value;
      const currentVariant = this.variants.find(
        (v) => String(v.id) === String(currentVariantId),
      );

      // 1. Build selected parameters list
      if (this.footerParams) {
        this.footerParams.innerHTML = "";
        let paramIndex = 1;

        allOptions.forEach((optionEl) => {
          const handle = optionEl.dataset.handle || "";
          const name = handle.replace(/-/g, " ");
          let selectedValue = "";

          const checkedRadio = optionEl.querySelector(
            'input[type="radio"]:checked',
          );
          if (checkedRadio) {
            selectedValue = checkedRadio.value;
          } else if (optionEl.dataset.value) {
            selectedValue = optionEl.dataset.value;
          }

          if (selectedValue) {
            const param = document.createElement("span");
            param.className = "product-configurator__footer-param";
            param.textContent = `${paramIndex}. ${name}: ${selectedValue}`;
            param.title = `${name}: ${selectedValue}`;
            this.footerParams.appendChild(param);
            paramIndex++;
          }
        });

        // Append selected mattress as an extra line
        const mattress = this.getSelectedMattress();
        if (mattress) {
          const param = document.createElement("span");
          param.className = "product-configurator__footer-param product-configurator__footer-param--mattress";
          param.textContent = `${paramIndex}. ${mattress.title} ${mattress.priceFormatted}`;
          param.title = `${mattress.title} ${mattress.priceFormatted}`;
          this.footerParams.appendChild(param);
          paramIndex++;
        }

        // Append selected fabric family as an extra line
        const fabricFamily = this.getSelectedFabricFamily();
        if (fabricFamily) {
          const param = document.createElement("span");
          param.className = "product-configurator__footer-param product-configurator__footer-param--fabric-family";
          param.textContent = `${paramIndex}. ${fabricFamily.title} ${fabricFamily.priceFormatted}`;
          param.title = `${fabricFamily.title} ${fabricFamily.priceFormatted}`;
          this.footerParams.appendChild(param);
          paramIndex++;
        }

        // Append selected generic surcharge products as extra lines
        const surchargeProducts = this.getAllSelectedSurchargeProducts();
        surchargeProducts.forEach((sp) => {
          const param = document.createElement("span");
          param.className = `product-configurator__footer-param product-configurator__footer-param--${sp.optionHandle}`;
          const label = sp.propertyName
            ? `${sp.propertyName}: ${sp.title}`
            : `${sp.title} ${sp.priceFormatted}`.trim();
          param.textContent = `${paramIndex}. ${label}`;
          param.title = label;
          this.footerParams.appendChild(param);
          paramIndex++;
        });
      }

      // 2. Update footer price to include mattress surcharge
      if (this.footerPrice) {
        if (currentVariant) {
          let totalPrice = currentVariant.price;
          const mattress = this.getSelectedMattress();
          if (mattress) {
            totalPrice += mattress.price;
          }
          const fabricFamily = this.getSelectedFabricFamily();
          if (fabricFamily) {
            totalPrice += fabricFamily.price;
          }
          const surchargeProducts = this.getAllSelectedSurchargeProducts();
          surchargeProducts.forEach((sp) => {
            totalPrice += sp.price;
          });
          const formatted = (totalPrice / 100)
            .toFixed(2)
            .replace(".", ",")
            .replace(/,00$/, "");
          this.footerPrice.textContent = `${formatted} ${this.currencySymbol}`;
          this.footerPrice.classList.remove("loading");
        }
      }

      // 3. Update button state
      if (this.footerSubmit) {
        this.footerSubmit.disabled = currentVariant ? !currentVariant.available : true;
      }

      // Show the footer
      this.footer.style.display = "";
    }

    /**
     * Submit add-to-cart using the same logic as the product-form.
     */
    addToCart() {
      if (!this.productForm) return;

      const variantSelect = this.productForm.querySelector('select[name="id"]');
      const quantityInput = this.productForm.querySelector(
        'input[name="quantity"]',
      );

      if (!variantSelect || !variantSelect.value) return;

      // Gather properties
      const properties = {};
      this.productForm
        .querySelectorAll('input[name*="properties["]')
        .forEach((prop) => {
          if (prop.value) {
            const name = prop.name.replace("properties[", "").replace("]", "");
            properties[name] = prop.value;
          }
        });

      const items = [
        {
          id: variantSelect.value,
          quantity: quantityInput ? quantityInput.value : "1",
          properties: properties,
        },
      ];

      // Add selected mattress as a second cart item
      const mattress = this.getSelectedMattress();
      if (mattress) {
        items.push({
          id: mattress.variantId,
          quantity: quantityInput ? quantityInput.value : "1",
        });
      }

      // Add selected fabric family surcharge as a separate cart item
      const fabricFamily = this.getSelectedFabricFamily();
      if (fabricFamily) {
        /* Wariant lozka zostaje na tkaninie BAZOWEJ - tkanina premium jest
           osobnym produktem doplaty. Bez tego koszyk opisywal lozko inna
           tkanina niz wybrana ("kolor tkaniny Truth 09" przy wybranym
           Muso 07 - zgloszone 26 sie 2026): kupujacy widzial dwie sprzeczne
           tkaniny, a zamowienie nie mowilo wprost, ktora obowiazuje.

           Dokladamy wiec do pozycji lozka wlasciwosc o TEJ SAMEJ nazwie co
           opcja tkaniny. Karta pozycji koszyka pomija wtedy opcje wariantu
           o tej nazwie (`snippets/line-item-card.liquid`), wiec widac jedna,
           wybrana tkanine - takze w zamowieniu, czyli w produkcji. Sposob
           skladania koszyka zostaje bez zmian: dalej dwie pozycje. */
        const nazwaOpcji = this.dataset.fabricOptionName;

        if (nazwaOpcji && fabricFamily.colorValue) {
          properties[nazwaOpcji] = fabricFamily.colorValue;
        }

        items.push({
          id: fabricFamily.variantId,
          quantity: quantityInput ? quantityInput.value : "1",
        });
      }

      // Add selected generic surcharge products as separate cart items
      const surchargeProducts = this.getAllSelectedSurchargeProducts();
      surchargeProducts.forEach((sp) => {
        if (sp.variantId) {
          items.push({
            id: sp.variantId,
            quantity: quantityInput ? quantityInput.value : "1",
          });
        } else if (sp.propertyName && sp.title) {
          properties[sp.propertyName] = sp.title;
        }
      });

      const payload = { items };

      this.footerSubmit.classList.add("loading");
      this.footerSubmit.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then((res) => {
          if (!res.ok) {
            return res.text().then((body) => {
              let message = 'Cart add failed (HTTP ' + res.status + ')';
              try {
                const errorData = JSON.parse(body);
                message = errorData.description || errorData.message || message;
              } catch (_) { /* response was HTML, not JSON */ }
              console.error("[Configurator] Cart add failed:", res.status, message);
              throw new Error(message);
            });
          }
          return res.json();
        })
        .then((data) => {
          if (data.items) {
            window.dispatchEvent(new CustomEvent("cartAdded", { detail: { added: true } }));
            window.dispatchEvent(new CustomEvent("cartCounterUpdate"));
          }
          setTimeout(() => {
            this.footerSubmit.classList.remove("loading");
            this.footerSubmit.disabled = false;
          }, 1000);
        })
        .catch((err) => {
          console.error("[Configurator] Add to cart error:", err);
          this.footerSubmit.classList.remove("loading");
          this.footerSubmit.disabled = false;
        });
    }

    /**
     * Reload the full product section by fetching the target URL.
     * Replaces the ENTIRE shopify-section content (so all custom elements
     * like product-form re-initialize properly), while preserving the
     * configurator drawer by detaching and re-inserting it.
     */
    /* Adres opcji prowadzacej do innego produktu jest golym adresem produktu,
       bez parametrow, z ktorymi ogladamy strone. W podgladzie szablonu
       (`?view=...`) znaczylo to zejscie na inny szablon, a wtedy identyfikatory
       sekcji przestawaly sie zgadzac i przebudowa konczyla sie TWARDYM
       przeladowaniem - strona wracala, a konfigurator sie zamykal (zgloszone
       26 sie 2026). Przenosimy wiec parametry podgladu na adres docelowy.
       Na sklepie tych parametrow nie ma, wiec nic sie nie zmienia. */
    adresZParametramiPodgladu(url) {
      try {
        const biezace = new URLSearchParams(window.location.search);
        const cel = new URL(url, window.location.origin);

        ["view", "preview_theme_id", "_fd", "pb"].forEach((nazwa) => {
          if (biezace.has(nazwa) && !cel.searchParams.has(nazwa)) {
            cel.searchParams.set(nazwa, biezace.get(nazwa));
          }
        });

        return cel.pathname + cel.search;
      } catch (e) {
        return url;
      }
    }

    /* Identyfikator sekcji niesie identyfikator SZABLONU
       (`shopify-section-template--123__main`), wiec ten sam blok ma inne id na
       produkcie o innym sufiksie szablonu. Dopasowanie po samym id zawodzilo
       wtedy po cichu i kod schodzil do twardego przeladowania. Szukamy wiec
       najpierw po id, a gdy nie ma - po NAZWIE sekcji, czyli czesci po "__". */
    znajdzSekcje(zrodlo, id) {
      const wprost = zrodlo.getElementById ? zrodlo.getElementById(id) : null;
      if (wprost) return wprost;

      const nazwa = id.split("__")[1];
      if (!nazwa) return null;

      return (
        [...zrodlo.querySelectorAll(".shopify-section")].find(
          (sekcja) => sekcja.id.split("__")[1] === nazwa,
        ) || null
      );
    }

    reloadProductSection(targetUrl) {
      const section =
        this.closest(".shopify-section") ||
        document.querySelector(".section--pdp")?.closest(".shopify-section");

      if (!section) {
        this.isNavigating = false;
        window.location.href = targetUrl;
        return;
      }

      const sectionId = section.id.replace("shopify-section-", "");

      // Fetch the full page (no section_id) so we get the complete DOM
      // including all sections below the product
      fetch(targetUrl)
        .then((res) => {
          if (!res.ok) throw new Error("HTTP " + res.status);
          return res.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const newSection = this.znajdzSekcje(doc, section.id);
          const newDrawerContent = doc.querySelector(
            "#drawer-product-configurator .drawer__scroll-inner",
          );
          const newFooterPrice = doc.querySelector("[data-footer-price]");
          const newConfiguratorEl = doc.querySelector("product-configurator");

          if (!newSection) {
            this.isNavigating = false;
            window.location.href = targetUrl;
            return;
          }

          // Save drawer scroll position BEFORE any DOM detach/replace
          const scrollContainer =
            this.content?.closest(".drawer__scroll") ||
            this.content?.closest(".drawer__body") ||
            this.content?.parentElement;
          const savedScrollTop = scrollContainer ? scrollContainer.scrollTop : 0;

          /* Sama liczba pikseli nie wystarcza: po przebudowie panel ma inna
             wysokosc, a perfect-scrollbar reinicjalizuje sie i zeruje pozycje
             pozniej, niz zdazymy ja przywrocic. Dlatego zapamietujemy KROK
             widoczny u gory kadru i przesuniecie wzgledem niego - po
             przebudowie odnajdujemy krok o tym samym numerze. */
          let savedAnchor = null;

          if (scrollContainer) {
            const kroki = [...this.content.querySelectorAll(".product-configurator__section")];
            const gora = scrollContainer.getBoundingClientRect().top;
            const widoczny = kroki.findIndex((k) => k.getBoundingClientRect().bottom > gora + 1);

            if (widoczny > -1) {
              savedAnchor = {
                index: widoczny,
                offset: kroki[widoczny].getBoundingClientRect().top - gora,
              };
            }
          }

          // Save mattress state BEFORE replacing drawer content
          let savedMattressTitle = null;
          let savedMattressIsNone = false;
          const activeCard = this.getActiveMattressCard();
          if (activeCard) {
            savedMattressTitle = activeCard.dataset.mattressTitle;
          } else {
            const noneRadio = this.content?.querySelector('#mattress-none');
            if (noneRadio && noneRadio.checked) savedMattressIsNone = true;
          }

          // 1. Detach the current configurator drawer so it survives section replacement
          const drawer = document.getElementById("drawer-product-configurator");
          const drawerPlaceholder = document.createComment("configurator-drawer-placeholder");
          if (drawer) {
            drawer.parentNode.insertBefore(drawerPlaceholder, drawer);
            drawer.remove();
          }

          // 2. Replace the ENTIRE section content with the new section
          //    This ensures product-form and all other custom elements
          //    properly re-initialize via connectedCallback
          section.innerHTML = newSection.innerHTML;

          // 3. Remove the new configurator drawer from the replaced section
          //    (we'll use our preserved one with the open drawer state)
          const newInsertedDrawer = section.querySelector("#drawer-product-configurator");
          let reInsertPoint = null;
          if (newInsertedDrawer) {
            reInsertPoint = newInsertedDrawer.nextSibling;
            newInsertedDrawer.remove();
          }

          // 4. Re-insert the preserved configurator drawer
          if (drawer) {
            if (reInsertPoint) {
              section.insertBefore(drawer, reInsertPoint);
            } else {
              section.appendChild(drawer);
            }
            drawerPlaceholder.remove();
          }

          // 5. Replace all other drawers (outside this section) that are product-specific
          const newDrawers = doc.querySelectorAll("drawer-section");
          newDrawers.forEach((newDrawer) => {
            if (newDrawer.id === "drawer-product-configurator") return;
            const currentDrawer = document.getElementById(newDrawer.id);
            if (currentDrawer) {
              currentDrawer.replaceWith(newDrawer.cloneNode(true));
            }
          });

          // Manually format the badge to "5.0/5" instead of relying on Judge.me JS
          // which prevents the "1 review" fallback while avoiding initializeBadges crashes.
          document.querySelectorAll('.jdgm-preview-badge').forEach((badge) => {
            const innerBadge = badge.querySelector('.jdgm-prev-badge');
            const textSpan = badge.querySelector('.jdgm-prev-badge__text');
            if (innerBadge && textSpan) {
              const numReviews = parseInt(innerBadge.getAttribute('data-number-of-reviews'), 10);
              if (numReviews > 0) {
                const ratingAttr = innerBadge.getAttribute('data-average-rating');
                const ratingVal = parseFloat(ratingAttr || "5").toFixed(1);
                textSpan.textContent = `${ratingVal}/5`;
              }
            }
            badge.classList.remove('jdgm-widget');
          });

          // Manually process timestamp spinners in the review drawer, because
          // Judge.me JS loses context when the DOM is replaced via AJAX.
          document.querySelectorAll('.jdgm-rev__timestamp.jdgm-spinner').forEach(span => {
            const content = span.getAttribute('data-content');
            if (content) {
              const datePart = content.split(' ')[0];
              const parts = datePart.split('-');
              if (parts.length === 3) {
                span.textContent = `${parts[2]}.${parts[1]}.${parts[0]}`;
              } else {
                span.textContent = datePart;
              }
            }
            span.classList.remove('jdgm-spinner');
          });

          // Re-initialize judge.me if it exists (for the review drawer pagination and form)
          if (window.jdgm && window.jdgm.initializeWidget) {
            setTimeout(() => {
              window.jdgm.initializeWidget();
            }, 200);
          }

          // 6. Update drawer options content
          if (newDrawerContent && this.content) {
            this.content.innerHTML = newDrawerContent.innerHTML;
          }

          // 7. Update component metadata for the new product
          if (newConfiguratorEl) {
            this.dataset.variants = newConfiguratorEl.dataset.variants;
            this.variants = JSON.parse(this.dataset.variants || "[]");
            this.dataset.currencySymbol =
              newConfiguratorEl.dataset.currencySymbol;
            this.currencySymbol = this.dataset.currencySymbol || "zł";
          }

          // 8. Update footer price
          if (newFooterPrice && this.footerPrice) {
            this.footerPrice.innerHTML = newFooterPrice.innerHTML;
            this.footerPrice.classList.add("loading");
          }

          // 9. Re-bind theme controls
          if (window.theme) {
            if (typeof window.theme.bindControls === "function") {
              window.theme.bindControls();
            }
            if (typeof window.theme.richtextParams === "function") {
              window.theme.richtextParams();
            }
          }

          // 10. Also replace other product-specific sections on the page
          //     (e.g. recommendations, related products)
          doc.querySelectorAll(".shopify-section").forEach((newSec) => {
            // already handled (po nazwie, bo id niesie identyfikator szablonu)
            if (newSec.id === section.id) return;
            if (newSec.id.split("__")[1] === section.id.split("__")[1]) return;
            
            // Skip global sections like header and footer so their event listeners stay active
            if (
              newSec.closest("header-menu") ||
              newSec.closest("footer") ||
              newSec.id.includes("header") ||
              newSec.id.includes("footer") ||
              newSec.id.includes("announcement")
            ) {
              return;
            }

            const currentSec = this.znajdzSekcje(document, newSec.id);
            if (currentSec) {
              currentSec.innerHTML = newSec.innerHTML;
            }
          });

          // 11. Re-sync everything for the newly injected content
          setTimeout(() => {
            this.isNavigating = false;
            this.productForm = document.querySelector("product-form");
            this.syncActiveStates();
            if (this.productForm && typeof this.productForm.updateVariant === 'function') {
              this.productForm.updateVariant();
            }

            // Restore mattress check state BEFORE filterMattresses
            if (savedMattressTitle) {
              const cards = Array.from(this.content.querySelectorAll('.product-configurator__option--mattress-card'));
              const matchCard = cards.find(c => c.dataset.mattressTitle === savedMattressTitle);
              if (matchCard) {
                const step = matchCard.closest('.product-configurator__step');
                if (step) this.setActiveOption(step, matchCard);
              }
            } else if (savedMattressIsNone) {
              const noneRadio = this.content.querySelector('#mattress-none');
              if (noneRadio) {
                const noneOption = noneRadio.closest('.product-configurator__option');
                const step = noneOption?.closest('.product-configurator__step');
                if (noneOption && step) this.setActiveOption(step, noneOption);
              }
            }

            this.filterMattresses();
            this.updatePrices();
            this.updateFooter();
            if (this.loader) this.loader.style.display = "none";

            // Re-bind option click handlers for the new drawer content
            this.content
              .querySelectorAll(".product-configurator__option")
              .forEach((l) => {
                l.addEventListener("click", (e) => {
                  e.preventDefault();
                  this.onOptionClick(l);
                });
              });

            this.bindFabricDetailsButtons();

            /* Przywrocenie pozycji przewinięcia po przebudowie panelu.

               KOLEJNOSC JEST NOSNA (zgloszenie 26 sie 2026 - panel skakal przy
               wyborze tkaniny z innego produktu): perfect-scrollbar przy
               `update()` przelicza zawartosc i sam rusza `scrollTop`, wiec
               ustawienie pozycji PRZED update bylo natychmiast nadpisywane.
               Do tego nowa tresc doczytuje zdjecia i rosnie, wiec jedno
               ustawienie nie wystarcza - powtarzamy je w nastepnej klatce
               i jeszcze raz po 150 ms.

               Warunek na `savedScrollTop` musi dopuszczac ZERO: przy wyborze
               z gory panelu zero jest poprawna pozycja, a `if (savedScrollTop)`
               ja pomijal. */
            const scrollEl =
              this.content?.closest(".drawer__scroll") ||
              this.content?.parentElement;

            // Update PerfectScrollbar instances on the drawer
            const drawerEl = this.closest("drawer-section");
            if (drawerEl && drawerEl.scrollbars) {
              drawerEl.scrollbars.forEach((s) => s.update());
            }

            if (scrollEl) {
              /* Pozycja liczona z KOTWICY (numer kroku plus przesuniecie), a gdy
                 kotwicy nie ma - z zapisanych pikseli. Ponawiamy przez ~1 s, bo
                 perfect-scrollbar i doczytywane zdjecia ruszaja pozycje jeszcze
                 kilka klatek po podmianie tresci. */
              const docelowa = () => {
                if (!savedAnchor) return savedScrollTop;

                const kroki = [...this.content.querySelectorAll(".product-configurator__section")];
                const krok = kroki[savedAnchor.index];

                if (!krok) return savedScrollTop;

                return (
                  scrollEl.scrollTop +
                  krok.getBoundingClientRect().top -
                  scrollEl.getBoundingClientRect().top -
                  savedAnchor.offset
                );
              };

              /* Poprawianie ustepuje uzytkownikowi - pierwszy ruch kolka, palca
                 albo klawisza je konczy. Bez tego kto zaraz po wyborze zaczyna
                 przewijac, jest przez ta sekunde sciagany z powrotem. Sygnalem
                 nie moze byc `scroll`, bo wywoluje je takze nasze wlasne
                 ustawienie pozycji. */
              const timery = [];
              let czynne = true;
              const zdarzenia = ["wheel", "touchstart", "touchmove", "keydown"];

              const przerwij = () => {
                if (!czynne) return;

                czynne = false;
                timery.forEach((t) => window.clearTimeout(t));
                zdarzenia.forEach((zd) => {
                  scrollEl.removeEventListener(zd, przerwij);
                  window.removeEventListener(zd, przerwij);
                });
              };

              zdarzenia.forEach((zd) => {
                scrollEl.addEventListener(zd, przerwij, { passive: true });
                window.addEventListener(zd, przerwij, { passive: true });
              });

              const przywroc = () => {
                if (!czynne) return;

                const cel = Math.max(0, Math.round(docelowa()));

                if (Math.abs(scrollEl.scrollTop - cel) > 1) scrollEl.scrollTop = cel;
              };

              przywroc();
              requestAnimationFrame(przywroc);
              [80, 200, 400, 700, 1000].forEach((ms) =>
                timery.push(window.setTimeout(przywroc, ms)),
              );
              timery.push(window.setTimeout(przerwij, 1100));
            }
          }, 150);
        })
        .catch((err) => {
          this.isNavigating = false;
          console.error("Error reloading product section:", err);
          window.location.href = targetUrl;
        });
    }

    /**
     * Re-bind click event listeners to fabric details buttons.
     */
    bindFabricDetailsButtons(container = document) {
      const fabricDetailsEl = document.querySelector("fabric-details");
      if (!fabricDetailsEl) return;

      const buttons = container.querySelectorAll(".fab-details-btn");
      buttons.forEach((btn) => {
        if (btn.dataset.bound) return;

        btn.addEventListener("click", (e) => {
          e.preventDefault();
          const handle = btn.dataset.handle;
          const drawerId = btn.getAttribute("aria-controls");

          if (handle && typeof fabricDetailsEl.fetchDetails === "function") {
            fabricDetailsEl.fetchDetails(handle);
          }

          if (drawerId) {
            window.dispatchEvent(
              new CustomEvent("drawerOpen", {
                detail: {
                  id: drawerId,
                },
              }),
            );
          }
        });

        btn.dataset.bound = "true";
      });
    }

    /**
     * Filter mattress cards based on the currently selected "Powierzchnia spania" value.
     * Shows only mattress cards that have a variant matching the selected size,
     * and updates the displayed price and radio value to that variant.
     */
    filterMattresses() {
      if (!this.content) return;

      const sizeHandle = this.dataset.bedSizeHandle;
      if (!sizeHandle) return;

      const sizeOption = this.productForm?.querySelector(
        `product-option[data-handle="${CSS.escape(sizeHandle)}"]`,
      );
      if (!sizeOption) return;

      const checkedRadio = sizeOption.querySelector(
        'input[type="radio"]:checked',
      );
      const selectedSize = checkedRadio
        ? checkedRadio.value
        : sizeOption.dataset.value || "";

      if (!selectedSize) return;

      // The line above the list names the sleeping surface the list is matched to.
      const sizeLabel = this.content.querySelector("[data-mattress-size-label]");
      if (sizeLabel) {
        const numbers = selectedSize.match(/\d+/g);
        sizeLabel.textContent = numbers && numbers.length >= 2
          ? `${numbers[0]} x ${numbers[1]} cm`
          : selectedSize;
      }

      const currencySymbol = this.currencySymbol;

      this.content
        .querySelectorAll(".product-configurator__option--mattress-card")
        .forEach((card) => {
          const variantsRaw = card.dataset.mattressVariants;
          if (!variantsRaw) return;

          let variants;
          try {
            variants = JSON.parse(variantsRaw);
          } catch (e) {
            return;
          }

          const match = variants.find((v) => v.size === selectedSize);

          if (match) {
            card.style.display = "";

            // Update radio value to the matched variant ID
            const radio = card.querySelector('input[type="radio"]');
            if (radio) {
              radio.value = match.id;
              radio.id = `mattress-${match.id}`;
            }
            const label = card.querySelector(".product-configurator__option-label");
            if (label) {
              label.setAttribute("for", `mattress-${match.id}`);
            }

            // Update displayed price
            const priceEl = card.querySelector("[data-mattress-price]");
            if (priceEl) {
              // Ten sam zapis co w Liquidzie i w projekcie: "+ 1 524 zl" - ze spacja
              // po plusie i ze spacja co trzy cyfry. Wczesniej skrypt pisal "+1728 zl",
              // wiec cena materaca wygladala inaczej niz cena stelaza tuz obok.
              const kwota = (grosz) => {
                const reszta = grosz % 100;
                return reszta
                  ? (grosz / 100).toLocaleString("pl-PL", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : Math.round(grosz / 100).toLocaleString("pl-PL");
              };

              // Rabat na materac nalicza sie w koszyku, wiec karta pokazuje go tak
              // samo jak koszyk: cena wyjsciowa przekreslona plus cena po rabacie.
              // Procent siedzi na karcie (ustawienie bloku formularza), nie w kodzie.
              const rabat = parseFloat(priceEl.dataset.mattressDiscount || "0") || 0;
              const cenaPelna = `+ ${kwota(match.price)} ${currencySymbol}`;

              if (rabat > 0) {
                // Zaokraglenie do pelnych zlotych: sklep ma format kwot bez groszy,
                // wiec Liquid pokazuje "1 555 zl" - bez tego skrypt pisal "1 555,20 zl"
                // i cena zmieniala sie po samym przelaczeniu rozmiaru.
                const poRabacie =
                  Math.round((match.price * (100 - rabat)) / 100 / 100) * 100;
                priceEl.innerHTML =
                  `+ <span data-mattress-price-final>${kwota(poRabacie)} ${currencySymbol}</span>` +
                  `<del data-mattress-price-full>${kwota(match.price)} ${currencySymbol}</del>`;
              } else {
                priceEl.textContent = cenaPelna;
              }
            }
          } else {
            const radio = card.querySelector('input[type="radio"]');
            if (radio?.checked) {
              radio.checked = false;

              const noneRadio = this.content.querySelector('#mattress-none');
              if (noneRadio) {
                noneRadio.checked = true;
                const noneOption = noneRadio.closest(
                  ".product-configurator__option",
                );
                const mattressStep = noneRadio.closest(
                  ".product-configurator__step",
                );
                if (mattressStep && noneOption) {
                  this.setActiveOption(mattressStep, noneOption);
                }
              }

              card.classList.remove("product-configurator__option--active");
            }

            card.style.display = "none";
          }

        });

      this.updateShowMore();
    }
  }

  customElements.define("product-configurator", ProductConfigurator);
}

/* Przycisk "Wroc do konfiguratora" (szuflada opisu tkaniny i szuflada opisu
   materaca) niesie NARAZ dwa polecenia: `data-drawer-close` obsluguje drawer.js,
   a `aria-controls="drawer-product-configurator"` lapie generyczna obsluga
   `[aria-controls*="drawer-"]` z main.js i OTWIERA konfigurator jeszcze raz.

   Na desktopie to bylo nieszkodliwe - `close()` zamyka szuflade od razu, a
   `pushHistoryState()` konczy sie na `isMobilePdpDrawer()`. Ponizej 768 px na
   karcie produktu `close()` NIE zamyka niczego samo: wola `history.back()` i
   czeka na `popstate`. Zanim popstate przyjdzie, main.js zdazy otworzyc
   konfigurator i dolozyc wpis historii z JEGO identyfikatorem. Gdy popstate
   w koncu przychodzi, `getHistoryDrawer()` zwraca juz konfigurator - zamyka sie
   wiec KONFIGURATOR, opis tkaniny zostaje na wierzchu, a cofniecie zjada wpis
   historii z biezacym wariantem (zgloszenie Mateusza, 390 x 878 px, tkanina
   STEP; przy 1200 px ta sama sekwencja dziala poprawnie).

   Zatrzymujemy wiec klikniecie w fazie PRZECHWYTYWANIA (obie obslugi wisza
   wprost na przycisku, wiec inaczej sie ich nie rozdzieli) i wykonujemy oba
   polecenia PO KOLEI, nie naraz:

   - konfigurator juz otwarty (opis otwarto z jego wnetrza): wystarczy zamknac
     wlasna szuflade, konfigurator caly czas lezy pod spodem;
   - konfigurator zamkniety (opis otwarto wprost z karty produktu - ta sciezka
     wisiala tak samo): otwieramy go dopiero, gdy opis naprawde sie zamknal,
     czyli po `drawerClosed`. Zegar jest zabezpieczeniem na wypadek, gdyby
     zdarzenie nie przyszlo. */
if (!window.__cossyDrawerBackGuard) {
  window.__cossyDrawerBackGuard = true;

  document.addEventListener(
    "click",
    (event) => {
      const przycisk =
        event.target.closest &&
        event.target.closest("[data-drawer-close][aria-controls]");

      if (!przycisk) return;

      const wlasna = przycisk.closest("drawer-section");
      const docelowa = document.getElementById(
        przycisk.getAttribute("aria-controls"),
      );

      if (!wlasna || !docelowa || wlasna === docelowa) return;

      event.preventDefault();
      event.stopPropagation();

      if (typeof wlasna.close !== "function") return;

      if (docelowa.classList.contains("drawer--opened")) {
        wlasna.close();
        return;
      }

      let otwarto = false;

      const otworz = () => {
        if (otwarto) return;
        otwarto = true;
        window.removeEventListener("drawerClosed", poZamknieciu);
        window.dispatchEvent(
          new CustomEvent("drawerOpen", { detail: { id: docelowa.id } }),
        );
      };

      function poZamknieciu(zdarzenie) {
        if (zdarzenie.detail && zdarzenie.detail.id !== wlasna.id) return;
        otworz();
      }

      window.addEventListener("drawerClosed", poZamknieciu);
      window.setTimeout(otworz, 800);

      wlasna.close();
    },
    true,
  );
}
